<script>
  import ListaDespesasRubricas from './FormListaDespesasRubricas.vue';
  import projetoServico from '~modulos/projeto/servico';
  
  export default {
    components: { ListaDespesasRubricas },
    props: {
      solicitacao: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        despesa: this.camposDespesa(),
        rubricas: [],
        subrubricas: [],
      }
    },
    methods: {
      camposDespesa() {
        return {
          idRubrica: '', 
          idSubrubrica: '',
          valorSolicitado: null,
          observacao: '',
          rubrica: {
            id: null,
            nome: '',
          },
          subrubrica: {
            id: null,
            nome: '',
          }
        }
      },
      validar() {
        this.$validator
          .validateAll()
          .then(valido => {
            if (valido) {
              this.adicionar();
            }
          })
      },
      adicionar() {
        const copiaDespesa = Object.assign(this.despesa);
        
        copiaDespesa.rubrica = this.rubricaSelecionada(copiaDespesa.idRubrica);
        copiaDespesa.subrubrica = this.subrubricaSelecionada(copiaDespesa.idSubrubrica);

        this.solicitacao.despesasViajem.push(copiaDespesa);

        this.despesa = this.camposDespesa();
        this.subrubricas = [];

        this.$validator.reset();
      },
      carregarRubricas() {
        this.rubricas = this.subrubricas = [];
        
        if (this.solicitacao.idProjeto === null) {
          return;
        }
        
        return projetoServico.
          rubricasAdiantamento(this.solicitacao.idProjeto)
          .then(rubricas => {
            this.rubricas = rubricas;
          })
      },
      carregarSubrubricas() {
        this.subrubricas = [];
        
        if (this.solicitacao.idProjeto === null || this.despesa.idRubrica === '') {
          return;
        }
        
        return projetoServico.
          subrubricasAdiantamento(this.solicitacao.idProjeto, this.despesa.idRubrica)
          .then(subrubricas => {
            this.subrubricas = subrubricas;
          })
      },
      rubricaSelecionada(idRubrica) {
        return this.rubricas.find(rubrica => rubrica.id == idRubrica);
      },
      subrubricaSelecionada(idSubrubrica) {
        return this.subrubricas.find(subrubrica => subrubrica.id == idSubrubrica);
      },
    },
    watch: {
      'solicitacao.idProjeto': 'carregarRubricas',
    }
  }
</script>

<template>
  <div>
    
    <div class="row">
      <div class="col-md-5">
        <div class="form-group required" :class="{'has-error': errors.has('rubrica')}">
          <label class="control-label" for="rubrica">Rubrica</label>

          <select
            class="form-control"
            id="rubrica"
            v-model="despesa.idRubrica"
            data-vv-name="rubrica"
            data-vv-as="rubrica"
            v-validate="'required'"
            @change="carregarSubrubricas">
            <option value="">Selecione...</option>
            <option :value="rubrica.id" v-for="rubrica in rubricas">{{ rubrica.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('rubrica')">{{ errors.first('rubrica') }}</p>
        </div>
      </div>
      
      <div class="col-md-5">
        <div class="form-group required" :class="{'has-error': errors.has('subrubrica')}">
          <label class="control-label" for="subrubrica">Subrubrica</label>

          <select
            class="form-control"
            id="subrubrica"
            v-model="despesa.idSubrubrica"
            data-vv-name="subrubrica"
            data-vv-as="subrubrica"
            v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="subrubrica.id" v-for="subrubrica in subrubricas">{{ subrubrica.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('subrubrica')">{{ errors.first('subrubrica') }}</p>
        </div>
      </div>
      
      <div class="col-md-2">
        <div class="form-group required" :class="{'has-error': errors.has('valorSolicitado')}">
          <label class="control-label" for="valor-solicitado">Valor</label>

          <input
            type="text"
            class="form-control text-right"
            id="valor-solicitado"
            v-model="despesa.valorSolicitado"
            data-vv-name="valorSolicitado"
            data-vv-as="valor"
            v-validate="'required'"
            v-mascara="'moeda'">

          <p class="text-danger" v-show="errors.has('valorSolicitado')">{{ errors.first('valorSolicitado') }}</p>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label class="control-label" for="observacao">Observação</label>

          <input
            type="text"
            class="form-control"
            id="observacao"
            maxlength="100"
            v-model="despesa.observacao">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <button type="button" class="btn btn-success" @click="validar">
            <i class="fa fa-plus"></i>
            Adicionar despesa
          </button>
        </div>
      </div>
    </div>

    <hr class="margin-top-10">

    <lista-despesas-rubricas
      :despesas="solicitacao.despesasViajem">
    </lista-despesas-rubricas>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-adiantamento/componentes/compartilhado/FormDespesasRubricas.vue